module.exports = __webpack_public_path__ + "static/img/guide.adfbb7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide.png
// module id = XEzK
// module chunks = 1